import React, { ReactNode } from "react";
import { Form } from "react-bootstrap";

type FactorFlagProperties = {
    parameter: FactorFlagParameter,
    callback: (paramName: string, value: string) => void,
    value?: boolean
}

type FactorFlagState = {
    checked: boolean
}

export default class FactorFlag extends React.Component<FactorFlagProperties, FactorFlagState> {

    constructor(props: FactorFlagProperties) {
        super(props);

        const defaultValue = props.parameter.default ?? false;
        
        this.state = {
            checked: props.value !== undefined ? props.value : defaultValue
        };
    }

    public componentDidMount(): void {
        // In controlled mode (value prop provided), do not emit initial default
        if (this.props.value === undefined) {
            this.props.callback(this.props.parameter.name, this.state.checked.toString());
        }
    }

    public reset(): void {
        const defaultValue = this.props.parameter.default ?? false;
        this.setState({
            checked: defaultValue
        });
    }

    public componentDidUpdate(prevProps: FactorFlagProperties): void {
        if (prevProps.value !== this.props.value && this.props.value !== undefined) {
            this.setState({ checked: this.props.value });
        }
    }

    public handleOnChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const checked = event.target.checked;
        this.setState({ checked });
        this.props.callback(this.props.parameter.name, checked.toString());
    }

    public render(): ReactNode {
        const { parameter } = this.props;
        const { checked } = this.state;

        return (
            <Form.Check
                type="switch"
                id={parameter.name}
                label={parameter.label || parameter.name}
                checked={checked}
                onChange={this.handleOnChange}
                style={{ fontSize: "14px" }}
            />
        );
    }
}
